import React from 'react';
import PropTypes from 'prop-types';

import {Card, CardContent, CardActions, Button, Typography, TextField, Box} from 'views/components';
import {CheckCircleOutline} from 'views/icons';
import {Translate} from 'views/module';

const QuestionCard = (props) => {
  const {
    questionInput,
    questionInputError,
    questionSubmitted,
    onQuestionInputChange,
    onQuestionSubmit,
    isSubmitting,
  } = props;

  return (
    <Card>
      {
        !questionSubmitted &&
        <>
          <CardContent>
            <Typography variant='body1' fontWeight={500} gutterBottom>
              <Translate expression={'dashboard.sections.info.question'}/>
            </Typography>
            <TextField
              sx={{
                '& .MuiOutlinedInput-root': {
                  'borderRadius': '20px',
                  'alignItems': 'flex-start',
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: !questionInputError ? 'grey.400' : 'error.main',
                  },
                },
                'width': '100%',
              }}
              onChange={onQuestionInputChange}
              minRows={7}
              maxRows={10}
              multiline
              value={questionInput}
            />
          </CardContent>
          <CardActions
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant='contained'
              onClick={onQuestionSubmit}
              loading={isSubmitting}
              disabled={isSubmitting}
              disableElevation
            >
              <Translate expression={'dashboard.sections.info.submit'}/>
            </Button>
          </CardActions>
        </>
      }
      {
        questionSubmitted &&
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 10,
            }}
          >
            <Box sx={{mr: 1}}>
              <CheckCircleOutline color='success' />
            </Box>
            <Box>
              <Typography variant='subtitle'>
                <Translate expression={'dashboard.sections.info.submissionConfirmationMessage.Title'}/>
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                <Translate expression={'dashboard.sections.info.submissionConfirmationMessage.Subtitle'}/>
              </Typography>
            </Box>
          </Box>
        </CardContent>
      }
    </Card>
  );
};

QuestionCard.propTypes = {
  questionInput: PropTypes.string.isRequired,
  questionInputError: PropTypes.bool.isRequired,
  questionSubmitted: PropTypes.bool.isRequired,
  onQuestionInputChange: PropTypes.func.isRequired,
  onQuestionSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default QuestionCard;
